import React from "react";
import ReactPlayer from "react-player";

const Player = ({ videoURL }) => {
  return (
    <>
      <div>
        <ReactPlayer
          width="800px"
          height="430px"
          controls
          url={videoURL}
          className="videoplayer-main-body"

          // onReady={() => console.log('onReady callback')}
          // onStart={() => console.log('onStart callback')}
          // onPause={() => console.log('onPause callback')}
          // onEnded={() => console.log('onEnded callback')}
          // onError={() => console.log('onError callback')}
        />
      </div>
    </>
  );
};

export default Player;